module.exports = __webpack_public_path__ + "fonts/31E180_3_0.97d92c4.woff2";